<div class="nav-bar">
  <div class="back-holder" (click)="backClicked()" id="backHolder">
    <img src="assets/general/back-blue.svg" />
  </div>
  <div class="title">قدم {{ currentStep }} از {{ totalSteps }}</div>
  <div class="progress-bar-container">
    <div class="progress-bar" id="progressBar"></div>
  </div>
</div>
